import { Link } from 'react-router'
import { errorMessage } from '../api/client.ts'
import { useMe, useTasks } from '../api/hooks.ts'
import { useNow } from '../lib/hooks.ts'
import { EmptyState, ErrorState, Logo } from '../ui/EmptyState.tsx'
import { Section } from '../ui/List.tsx'
import { Screen, ScreenHeader } from '../ui/ScreenHeader.tsx'
import { SkeletonList } from '../ui/Skeleton.tsx'
import { TaskCell } from '../ui/TaskCell.tsx'

/** Задачи, где я наблюдатель. */
export function WatchingScreen() {
  const me = useMe()
  const meId = me.data?.id ?? 0
  const tasks = useTasks({ scope: 'watching' }, Boolean(me.data))
  const now = useNow()
  const list = tasks.data ?? []
  return (
    <Screen label="Наблюдаю">
      <ScreenHeader back title="Наблюдаю" small />
      <p className="screen-subtitle">Задачи коллег, за которыми вы следите</p>
      {tasks.isPending ? (
        <SkeletonList rows={3} />
      ) : tasks.isError ? (
        <ErrorState text={errorMessage(tasks.error)} onRetry={() => void tasks.refetch()} />
      ) : list.length === 0 ? (
        <EmptyState title="Пока ничего" text="Когда вас добавят наблюдателем, задача появится здесь." />
      ) : (
        <Section id="watching" count={list.length} title="Открытые">
          {list.map((t) => (
            <TaskCell key={t.id} task={t} meId={meId} lead="assignee" now={now} />
          ))}
        </Section>
      )}
    </Screen>
  )
}

export function NotFoundScreen() {
  return (
    <Screen label="Страница не найдена">
      <ScreenHeader back title="Не нашли" small />
      <EmptyState
        title="Такой страницы нет"
        text="Возможно, ссылка устарела."
        action={
          <Link to="/" replace className="btn btn--secondary">
            К моим задачам
          </Link>
        }
      />
    </Screen>
  )
}

/** Открыли не в Telegram (и это не режим разработки). */
export function OutsideTelegram() {
  return (
    <div className="fatal">
      <div className="empty">
        <div className="empty__logo">
          <Logo />
        </div>
        <div className="empty__title">Откройте OVO Задачи в Telegram</div>
        <div className="empty__text">
          Приложение работает внутри Telegram: откройте бота компании и нажмите кнопку меню «Задачи».
        </div>
      </div>
    </div>
  )
}

/** Вход не подтверждён: сотрудник не найден или initData устарел. */
export function AuthProblem({ text, onRetry }: { text: string; onRetry: () => void }) {
  return (
    <div className="fatal">
      <div className="empty">
        <div className="empty__logo">
          <Logo />
        </div>
        <div className="empty__title">Не получилось войти</div>
        <div className="empty__text">{text}</div>
        <div className="empty__text">
          Если вы новый сотрудник — откройте ссылку-приглашение от администратора, затем вернитесь сюда.
        </div>
        <button type="button" className="btn btn--secondary" onClick={onRetry}>
          Попробовать ещё раз
        </button>
      </div>
    </div>
  )
}
